import { useState } from "react";
import { usePatients } from "../../context/PatientsContext";
import Button from "../ui/Button";

export default function PatientForm({ initialData = {}, onSuccess, onCancel }) {
  const { createPatient, updatePatient } = usePatients();

  const [formData, setFormData] = useState({
    id: initialData.id || "",
    firstName: initialData.firstName || "",
    lastName: initialData.lastName || "",
    email: initialData.email || "",
    phone: initialData.phone || "",
    cnp: initialData.cnp || "",
    city: initialData.city || "",
    isMinor: initialData.isMinor || false,
    legalRepresentative: initialData.legalRepresentative || {
      firstName: "",
      lastName: "",
      city: "",
      relation: "",
    },
    notes: initialData.notes || "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name.includes(".")) {
      const [group, field] = name.split(".");
      setFormData((prev) => ({
        ...prev,
        [group]: { ...prev[group], [field]: value },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      let savedPatient;
      if (formData.id) {
        savedPatient = await updatePatient(formData.id, formData);
      } else {
        savedPatient = await createPatient(formData);
      }
      if (onSuccess) onSuccess(savedPatient);
    } catch (err) {
      console.error("Eroare la salvarea pacientului:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input
          type="text"
          name="lastName"
          placeholder="Nume"
          value={formData.lastName}
          onChange={handleChange}
          className="border p-2 rounded-lg"
          required
        />
        <input
          type="text"
          name="firstName"
          placeholder="Prenume"
          value={formData.firstName}
          onChange={handleChange}
          className="border p-2 rounded-lg"
          required
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input
          type="email"
          name="email"
          placeholder="Email (opțional)"
          value={formData.email}
          onChange={handleChange}
          className="border p-2 rounded-lg"
        />
        <input
          type="text"
          name="phone"
          placeholder="Telefon"
          value={formData.phone}
          onChange={handleChange}
          className="border p-2 rounded-lg"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <input
          type="text"
          name="cnp"
          placeholder="CNP"
          value={formData.cnp}
          onChange={handleChange}
          className="border p-2 rounded-lg"
          required
        />
        <input
          type="text"
          name="city"
          placeholder="Oraș"
          value={formData.city}
          onChange={handleChange}
          className="border p-2 rounded-lg"
        />
      </div>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          name="isMinor"
          checked={formData.isMinor}
          onChange={handleChange}
        />
        Este minor
      </label>

      {formData.isMinor && (
        <div className="border p-3 rounded-lg">
          <p className="text-sm font-semibold mb-2">Reprezentant legal</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input
              type="text"
              name="legalRepresentative.firstName"
              placeholder="Prenume"
              value={formData.legalRepresentative.firstName}
              onChange={handleChange}
              className="border p-2 rounded-lg"
            />
            <input
              type="text"
              name="legalRepresentative.lastName"
              placeholder="Nume"
              value={formData.legalRepresentative.lastName}
              onChange={handleChange}
              className="border p-2 rounded-lg"
            />
            <input
              type="text"
              name="legalRepresentative.city"
              placeholder="Oraș"
              value={formData.legalRepresentative.city}
              onChange={handleChange}
              className="border p-2 rounded-lg"
            />
            <input
              type="text"
              name="legalRepresentative.relation"
              placeholder="Relație (ex: părinte)"
              value={formData.legalRepresentative.relation}
              onChange={handleChange}
              className="border p-2 rounded-lg"
            />
          </div>
        </div>
      )}

      <textarea
        name="notes"
        placeholder="Note"
        value={formData.notes}
        onChange={handleChange}
        className="w-full border p-2 rounded-lg"
        rows="3"
      ></textarea>

      {error && <p className="text-red-600 text-sm">{error}</p>}

      <div className="flex justify-end gap-3">
        {onCancel && (
          <Button variant="secondary" onClick={onCancel}>
            Anulează
          </Button>
        )}
        <Button type="submit" variant="primary" disabled={loading}>
          {loading ? "Se salvează..." : "Salvează pacientul"}
        </Button>
      </div>
    </form>
  );
}
